import { render, staticRenderFns } from "./TripRegistration.vue?vue&type=template&id=377e7051&scoped=true"
import script from "./TripRegistration.vue?vue&type=script&lang=js"
export * from "./TripRegistration.vue?vue&type=script&lang=js"
import style0 from "./TripRegistration.vue?vue&type=style&index=0&id=377e7051&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377e7051",
  null
  
)

export default component.exports